<template>
    <div class="shadow-md p-3">
      404 - page not found
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
      };
    },
    computed: {
    },
    methods: {
    },
    mounted() {
    },
  };
  </script>

